export const BP_ROLE_TYPE = {
  DESIGN_PARTNER: 5,
  MERCHANDISE_VENDOR: 8,
  FABRIC_SUPPLIER: 7,
  TRIM_SUPPLIER: 10,
  PACKAGING_SUPPLIER: 27,
  FRAGRANCE_SUPPLIER: 311,
  FOOTWEAR_SUPPLIER: 312,
  YARN_SUPPLIER: 313,
}

export const PLM_SUPPORTED_ROLE_TYPES = [
  BP_ROLE_TYPE.DESIGN_PARTNER,
  BP_ROLE_TYPE.FABRIC_SUPPLIER,
  BP_ROLE_TYPE.MERCHANDISE_VENDOR,
  BP_ROLE_TYPE.TRIM_SUPPLIER,
  BP_ROLE_TYPE.FRAGRANCE_SUPPLIER,
  BP_ROLE_TYPE.FOOTWEAR_SUPPLIER,
  BP_ROLE_TYPE.YARN_SUPPLIER,
  BP_ROLE_TYPE.PACKAGING_SUPPLIER,
]

export const BP_ROLE_TYPE_LOOKUP_TABLE = {
  5: 'Design partner',
  8: 'Merchandise vendor',
  7: 'Fabric supplier',
  10: 'Trim supplier',
  22: 'Production/Storage facility owner',
  27: 'Packaging supplier',
  311: 'Target designated - fragrance',
  312: 'Footwear supplier',
  313: 'Yarn supplier',
}

export const BP_ROLE_DESCRIPTION = {
  5: 'For external partners that own a brand trademark and collaborate with Target on design work for one or more owned or exclusive brands.',
  8: "For vendors that receive purchase orders from Target and ship finished goods through Target's supply chain or directly to guests.",
  7: 'For partners that produce fabric used by merchandise vendors.',
  10: 'For partners that supply trims or components, such as buttons, zippers, labels, or other finishing materials.',
  22: 'For companies contracted by a supply chain vendor, not Target, that own all or a majority share of a production or storage facility.',
  27: 'For partners that produce or supply packaging materials for products.',
  311: 'For Target-designated partners that support fragrance development, sourcing, or supply.',
  312: 'For partners that produce or supply footwear products or footwear components.',
  313: 'For partners that produce or supply yarn used in fabric or product production.',
}

export const LOGOUT_WARNING_MESSAGE =
  'You will need to log out of your current session in order to save changes and update your partner type settings.'
